
(function(){
document.documentElement.classList.add('js');
function $(s,c){return (c||document).querySelector(s);}
function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
// mobile menu
var burger=$('#burger'), menu=$('#menu');
if(burger) burger.addEventListener('click',function(){menu.classList.toggle('open');});
// dropdown
document.addEventListener('click',function(e){
  if(!e.target.closest('.menu')){$all('.mi.open').forEach(function(m){m.classList.remove('open');});}
  var dd=e.target.closest('[data-dd]');
  if(dd){e.preventDefault();var mi=dd.closest('.mi');var was=mi.classList.contains('open');$all('.mi').forEach(function(m){m.classList.remove('open');});if(!was)mi.classList.add('open');}
});
// reveal
function reveal(){
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches){$all('.rv-an').forEach(function(e){e.classList.add('in');});return;}
  var o=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');o.unobserve(en.target);}});},{rootMargin:'0px 0px -8% 0px'});
  $all('.rv-an:not(.in)').forEach(function(e){o.observe(e);});
}
reveal();
// product gallery
var gth=$('#gth'), gmi=$('#gmi');
if(gth&&gmi){gth.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;gmi.src=b.getAttribute('data-im');$all('button',gth).forEach(function(x){x.classList.remove('on');});b.classList.add('on');});}
// sticky pdp bar
var stk=$('#stk'), mainadd=$('#mainadd');
if(stk&&mainadd){
  var o2=new IntersectionObserver(function(es){es.forEach(function(en){stk.classList.toggle('on',!en.isIntersecting&&en.boundingClientRect.top<0);});},{threshold:0});
  o2.observe(mainadd);
}
// variant selection (radio style)
$all('.vopt input').forEach(function(inp){
  inp.addEventListener('change',function(){
    var grp=inp.name;
    $all('.vopt').forEach(function(l){ if($('input[name="'+grp+'"]',l)) l.classList.toggle('sel', $('input',l).checked);});
    updateVariant();
  });
});
function selectedOptions(){return $all('.vopt input:checked').map(function(i){return i.value;});}
function updateVariant(){
  var data=$('#variant-data'); if(!data) return;
  var variants=JSON.parse(data.textContent); var sel=selectedOptions();
  var match=variants.find(function(v){return v.options.join(' / ')===sel.join(' / ');});
  var idEl=$('#variant-id'), priceEl=$('#pdp-price'), btn=$('#mainadd');
  if(match){idEl.value=match.id; if(priceEl)priceEl.textContent='$'+(match.price/100).toLocaleString('en-NZ',{minimumFractionDigits:2})+' NZD'; if(btn){btn.disabled=!match.available; btn.textContent=match.available?btn.getAttribute('data-label'):'Sold out';}}
}
// cart drawer (AJAX)
var drawer=$('#drawer'), scrim=$('#scrim'), cartb=$('#cartb');
function openCart(){if(drawer){drawer.classList.add('on');scrim.classList.add('on');}}
function closeCart(){if(drawer){drawer.classList.remove('on');scrim.classList.remove('on');}}
if(cartb) cartb.addEventListener('click',function(e){e.preventDefault();openCart();fetchCart();});
var dx=$('#dx'); if(dx) dx.addEventListener('click',closeCart);
if(scrim) scrim.addEventListener('click',closeCart);
function money(c){return '$'+(c/100).toLocaleString('en-NZ',{minimumFractionDigits:2});}
function fetchCart(){
  fetch('/cart.js').then(function(r){return r.json();}).then(renderCart);
}
function renderCart(cart){
  var body=$('#db'), tot=$('#ctot'), cc=$('#cc');
  if(cc){cc.textContent=cart.item_count;cc.style.display=cart.item_count>0?'grid':'none';}
  var dgo=$('#dgo'),dem=$('#dempty');
  if(dgo)dgo.style.display=cart.item_count>0?'':'none';
  if(dem)dem.style.display=cart.item_count>0?'none':'';
  if(!body) return;
  if(!cart.items.length){body.innerHTML='<div class="empty">Your cart is empty.</div>';tot.textContent='$0';return;}
  body.innerHTML=cart.items.map(function(it){
    return '<div class="ci"><div class="im"><img src="'+(it.image||'')+'" style="width:100%;height:100%;object-fit:cover"></div><div style="flex:1"><h4>'+it.product_title+'</h4><div style="font-size:12px;color:var(--muted)">Qty '+it.quantity+'</div><div class="cp">'+money(it.final_line_price)+'</div><button class="rm" data-key="'+it.key+'">Remove</button></div></div>';
  }).join('');
  tot.textContent=money(cart.total_price);
  $all('.rm',body).forEach(function(b){b.addEventListener('click',function(){changeItem(b.getAttribute('data-key'),0);});});
}
function changeItem(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
}
// add to cart via form
$all('form[action="/cart/add"]').forEach(function(form){
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){return r.json();}).then(function(){openCart();fetchCart();});
  });
});
fetchCart();
})();
